module.exports = "<header>\n  <div class=\"img\"></div>\n  <h3>{{'Game not found' | translate}}</h3>\n</header>\n<p>{{'We\\'re sorry' | translate}}</p>\n<p>{{'But it was not possible to find the requested page' | translate}}</p>\n<button onclick=\"history.back(2)\">{{'Go back' | translate}}</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main